// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRightOutlinedSvg from "@fishx/icons-svg/es/asn/PRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PRightOutlined = function PRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRightOutlinedSvg
  }));
};

PRightOutlined.displayName = 'PRightOutlined';
export default React.forwardRef(PRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRightOutlined.js
// module id = 3593
// module chunks = 0